import styled from "styled-components";
import { AgGridContainerProps } from "./AgGridComponent.types";

export const AgGridWrapper = styled.div`
  height: calc(100dvh - 105px);
`;

export const AgGridContainer = styled.div<AgGridContainerProps>`
  width: 100%;
  height: ${(props) => props.height || "calc(100dvh - 200px)"};

  --ag-header-background-color: transparent !important;
  --ag-border-color: rgba(255, 255, 255, 0.2) !important;

  .ag-horizontal-right-spacer,
  .ag-body-horizontal-scroll-container {
    background-color: white !important;
  }

  .ag-column-drop-horizontal,
  .ag-header-container {
    background-color: rgb(68 62 62 / 76%) !important;
  }

  .ag-header-cell-text,
  .ag-header-group-cell-label {
    color: white !important;
  }
  .ag-header-icon,
  .ag-sort-indicator-icon {
    color: white !important;
  }
.ag-right-aligned-cell {
  text-align: right !important;
  justify-content: flex-end; /* for flex cells */
}
  .ag-root-wrapper {
    background-color: transparent !important;
  }

  .non-editable-cell {
    background-color: #c0bbbb8f; /* light grey */
    color: #999;
  }

  .ag-column-drop,
  .ag-column-drop-cell,
  .ag-icon-grip {
    color: white !important;
  }

  .ag-row {
    background-color: rgba(26, 39, 68, 0.82) !important;
  }

  .ag-row:hover {
    background-color: rgba(42, 58, 95, 0.95) !important;
  }

  .custom-group-row {
    background-color: rgba(26, 39, 68, 0.82) !important;
  }

  .custom-group-row:hover {
    background-color: rgba(26, 39, 68, 0.82) !important;
  }
  .custom-group-row .ag-cell,
  .custom-group-row .ag-group-cell {
    background-color: inherit !important;
  }

  .ag-status-bar {
    background-color: rgba(0, 0, 0, 0.35) !important;
  }

  .ag-status-name-value,
  .ag-status-name-value-value {
    color: white !important;
  }

  .ag-root-wrapper {
    border-radius: 5px 0 0 0 !important;
  }
`;

export const AgGridSearchWrapper = styled.div`
  padding: 8px 0;
`;
